export const SUCCESS_MESSAGES = {
    ADDED_DATA: 'Мэдээллийг амжилттай нэмлээ',
    ADDED_POSTER: 'Постерийг амжилттай хууллаа',
    EDITED_DATA: 'Мэдээллийг амжилттай шинэчиллээ',
    DELETED_DATA: 'Мэдээллийг амжилттай устгалаа',
    CREATED_WEEK_RANGE:
        '7 хоногийн мэдээллийг амжилттай бүртгэлээ. Файлыг хуулна уу.',
    APPROVED: 'Хөтөлбөр амжилттай батлагдлаа',
    DISAPPROVED: 'Хөтөлбөр амжилттай буцаагдлаа',
    DOWNLOADED: 'Хөтөлбөр амжилттай татагдлаа',
    FilEDOWNLOADED: 'Засварлах файлын template амжилттай татагдлаа',
    FILEUPDATED: 'Хөтөлбөр амжилттай засварлагдлаа',
};

export const ERROR_MESSAGES = {
    REQUEST_FAIL: 'Уучлаарай алдаа гарлаа',
    FILL_REQUIRED_FIELDS: 'Талбаруудыг гүйцэд бөглөнө үү',
    FILL_THE_FORM: 'Шаардлагатай талбаруудыг гүйцэд бөглөнө үү',
    FILL_THE_FIELD: 'Энэ талбарыг бөглөнө үү',
    FILE_SIZE_TOO_BIG: 'Файлын хэмжээ хэтэрхий том байна',
    FILE_NOT_FOUND: 'Файл оруулна уу',
    NOT_MATCHED: 'Нууц үг тохирохгүй байхын',
    NOT_MATCHED_DATE_RANGE: 'Эхлэх дуусах өдрийн хооронд 7 өдөр байх ёстой',
    NOT_IN_DATE_RANGE: 'Хөтөлбрөөс гадуур өдөр оруулсан байна',
    GRAPH_DATA_IS_EMPTY: 'Харуулах графикийн мэдээлэл байхгүй байна',
    DATE_ERROR: 'Эхлэх өдөр дуусах өдрөөс их байна',
};
